import { useEffect, useMemo, useState } from "react";

import TeamMembers from "../Organization/components/TeamMembers";
import Detailltem from "../Organization/components/Detailltem";
import DetailltemMore from "../Organization/components/DetailltemMore";
import { Collapse } from "antd";
import ChinaFlag from "../../components/icons/flags/ChinaFlag";
import IndiaFlag from "../../components/icons/flags/IndiaFlag";
import HongKongFlag from "../../components/icons/flags/HongKongFlag";
import IndonesiaFlag from "../../components/icons/flags/IndonesiaFlag";
import JapanFlag from "../../components/icons/flags/JapanFlag";
import MalasiaFlag from "../../components/icons/flags/MalasiaFlag";
import PhlippinesFlag from "../../components/icons/flags/PhlippinesFlag";
import SingaporeFlag from "../../components/icons/flags/SingaporeFlag";
import SKoreaFlag from "../../components/icons/flags/SKoreaFlag";
import TaiwanFlag from "../../components/icons/flags/TaiwanFlag";
import ThailandFlag from "../../components/icons/flags/ThailandFlag";
import VietnamFlag from "../../components/icons/flags/VietnamFlag";
import AustraliaFlag from "../../components/icons/flags/AustraliaFlag";
import PartnerMarketDetails from "./PartnerMarketDetails";
import { KeyboardArrowDown } from "@mui/icons-material";
import DownArrowIconLarge from "../../components/icons/DownArrowIconLarge";

interface Props {
  data: any
  noScroll?: boolean;
}
const PartnerInfo = (props: Props) => {
  const { data, noScroll = false } = props

  const [markets, setMarkets] = useState<any[]>([]);

  useEffect(() => {
    setMarkets(data?.market || [])
  }, [data])


  const flagIcon = (country: string) => {
    switch (country) {
      case "China":
        return <ChinaFlag />
      case "Hong Kong":
        return <HongKongFlag />
      case "India":
        return <IndiaFlag />
      case "Indonesia":
        return <IndonesiaFlag />
      case "Japan":
        return <JapanFlag />
      case "Malaysia":
        return <MalasiaFlag />
      case "Philippines":
        return <PhlippinesFlag />
      case "Singapore":
        return <SingaporeFlag />
      case "South Korea":
        return <SKoreaFlag />
      case "Taiwan":
        return <TaiwanFlag />
      case "Thailand":
        return <ThailandFlag />
      case "Vietnam":
        return <VietnamFlag />
      case "Australia":
        return <AustraliaFlag />
      case "Thailand":
        return <ThailandFlag />

      default:
        return <></>
    }
  }

  const panelStyle: React.CSSProperties = {
    marginBottom: 12,
    border: 'none',
    borderRadius: "8px",
    backgroundColor: "#FFF"
  };

  const marketsList = useMemo(() => {
    return markets?.map((item: any, index: number) => {
      return {
        key: index + 1,
        label: (
          <div className="flex items-center gap-x-[8px]">
            {flagIcon(item?.country?.name)}
            <p className="m-0 text-[13px] font-[500]">{item?.country?.name}</p>
          </div>
        ),
        children: (
          <PartnerMarketDetails data={item} />
        ),
        style: panelStyle
      }
    })
  }, [markets])
  return (
    <div className="gap-[16px]">
      <div className={`${noScroll ? "" : "overflow-auto h-[calc(100vh-220px)]"} w-full`}>
        <div className="mb-[40px]">
          <Collapse
            expandIconPosition="end"
            defaultActiveKey="1"
            expandIcon={({ isActive }) => <DownArrowIconLarge className={`${isActive ? "rotate-180" : "rotate-0"}`} />}
            bordered={false}
            items={marketsList}
          />
        </div>
      </div>
    </div>
  )
}

export default PartnerInfo